module.exports = __webpack_public_path__ + "static/media/expand-wide.e1f4391b.svg";